import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { getIcon } from '@services/dashboardResource';
import { Td, Row } from '@layout/DashboardTable';
import { Button } from '@atoms';
import { FlexContainer } from '@layout';
import messages from './messages';

const OrganizationsTableHead = ({ order, sortBy }) => (
  <thead>
    <Row>
      <Td primary>
        <FormattedMessage {...messages.tableHeaderId} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.organizationName} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.company} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.country} />
      </Td>
      <Td primary>
        <Button invisible name="date" onClick={sortBy} id="sort-list-by-date">
          <FlexContainer inline gap="5px">
            <FormattedMessage {...messages.connectionStatus} />
            {/* <img src={getIcon(order, 'date')} /> */}
          </FlexContainer>
        </Button>
      </Td>
      <Td primary />
    </Row>
  </thead>
);

OrganizationsTableHead.propTypes = {
  // order: PropTypes.string.isRequired,
  // sortBy: PropTypes.func.isRequired,
  // showTranscripts: PropTypes.bool
};

OrganizationsTableHead.defaultProps = {
  showTranscripts: false,
};

export default OrganizationsTableHead;



// WEBPACK FOOTER //
// ./components/organisms/OrganizationsTable/OrganizationsTableHead.js